module.exports = __webpack_public_path__ + "static/media/KaTeX_SansSerif-Italic.1057b702.woff2";